import './../stylesheets/donations';

import * as kenAllComponent from './components/ken_all';
import * as currencyComponent from './components/currency';
import * as spinnerComponent from './components/spinner';
import * as select2Component from './components/select2';
import * as modalComponent from './components/modal';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // 住所のアクション
  kenAllComponent.setAdrresEvent();
  // 金額入力フィールドのアクション
  currencyComponent.displayYenField();
  currencyComponent.yenField();
  // 寄附情報一覧のアクション
  donationsActions();
  // 寄附のお申し込みのアクション
  donationFormActions();
})

// 寄附情報一覧のアクション
export function donationsActions() {
  // フォームを取得
  let ApiDonationForm = document.getElementById('api-donation-data-form');
  if (!!ApiDonationForm) {
    // クラウドファンディング
    var ApiDonationCrowdFundingSelectElement = document.getElementById('api_donation_data_crowd_funding_id');
    if (!!ApiDonationCrowdFundingSelectElement) {
      ApiDonationCrowdFundingSelectElement.addEventListener('change', function(event) {
        donationDataReplace();
      });
    }

    // 区分
    let ApiDonationDataDivisionSelectElements = document.querySelectorAll('input[name="api_donation_data[division]"]');
    if (!!ApiDonationDataDivisionSelectElements.length) {
      for (var i = 0; i < ApiDonationDataDivisionSelectElements.length; i++) {
        ApiDonationDataDivisionSelectElements[i].addEventListener('change', function(event) {
          var ApiDonationDataFiscalYearSelectElement = document.getElementById('api_donation_data_fiscal_year');
          var ApiDonationCrowdFundingSelectElement = document.getElementById('api_donation_data_crowd_funding_id');

          if (this.value == 'crowd_funding') {
            if (!!ApiDonationDataFiscalYearSelectElement) {
              ApiDonationDataFiscalYearSelectElement.disabled = false;
            }
            if (!!ApiDonationCrowdFundingSelectElement) {
              ApiDonationCrowdFundingSelectElement.disabled = false;
            }
          } else {
            if (!!ApiDonationDataFiscalYearSelectElement) {
              ApiDonationDataFiscalYearSelectElement.disabled = true;
            }
            if (!!ApiDonationCrowdFundingSelectElement) {
              ApiDonationCrowdFundingSelectElement.disabled = true;
            }
          }
          donationDataReplace();
        });
      }
    }

    // 削除区分
    let ApiDonationDataDeleteDivisionSelectElements = document.querySelectorAll('input[name="api_donation_data[delete_division]"]');
    if (!!ApiDonationDataDeleteDivisionSelectElements.length) {
      for (var i = 0; i < ApiDonationDataDeleteDivisionSelectElements.length; i++) {
        ApiDonationDataDeleteDivisionSelectElements[i].addEventListener('change', function(event) {
          donationDataReplace();
        });
      }
    }

    // 事業年度
    var ApiDonationDataFiscalYearSelectElement = document.getElementById('api_donation_data_fiscal_year');
    if (!!ApiDonationDataFiscalYearSelectElement && !!ApiDonationCrowdFundingSelectElement) {
      ApiDonationDataFiscalYearSelectElement.addEventListener('change', function(event) {
        // クラウドファンディングの選択しているオプションを取得
        let crowdFundingSelectedIndex = ApiDonationCrowdFundingSelectElement.options.selectedIndex;
        let crowdFundingSelectedOption = ApiDonationCrowdFundingSelectElement.options[crowdFundingSelectedIndex];
        let crowdFundingSelectedfiscalYear = crowdFundingSelectedOption.dataset.fiscalYear;

        // クラウドファンディングのオプションでd-noneのクラスのものを抽出してクラスを削除
        var crowdFundingOptions = ApiDonationCrowdFundingSelectElement.querySelectorAll('option.d-none');
        if (!!crowdFundingOptions.length) {
          for (var i = 0; i < crowdFundingOptions.length; i++) {
            crowdFundingOptions[i].classList.remove('d-none');
          }
        }

        if (!!this.value) {
          // 年度の選択しているオプションを取得
          let fiscalYearSelectedIndex = ApiDonationDataFiscalYearSelectElement.options.selectedIndex;
          // 選択された年度以外のクラウドファンディングにd-noneのクラスを追加
          for (var i = 0; i < ApiDonationDataFiscalYearSelectElement.options.length; i++) {
            var fiscalYear = ApiDonationDataFiscalYearSelectElement.options[i].value;
            if (i != fiscalYearSelectedIndex && !!fiscalYear) {
              var crowdFundingOptions = ApiDonationCrowdFundingSelectElement.querySelectorAll('option[data-fiscal-year="' + fiscalYear + '"]');
              if (!!crowdFundingOptions.length) {
                for (var i = 0; i < crowdFundingOptions.length; i++) {
                  crowdFundingOptions[i].classList.add('d-none');
                }
              }
            }
          }
          if (!crowdFundingSelectedIndex || crowdFundingSelectedOption.classList.contains('d-none')) {
            ApiDonationCrowdFundingSelectElement.options[0].selected = true;
            ApiDonationCrowdFundingSelectElement.dispatchEvent(new Event('change'));
          }
        } else {
          ApiDonationCrowdFundingSelectElement.options[0].selected = true;
          ApiDonationCrowdFundingSelectElement.dispatchEvent(new Event('change'));
        }
      });
    }

    // ダウンロード
    let donationIndexDownloadButton = document.getElementById('api_donation_data_download_button');
    if (!!donationIndexDownloadButton) {
      donationIndexDownloadButton.addEventListener('click', function(event) {
        // フォームをサブミット
        ApiDonationForm.submit();
        // 削除区分の選択肢を取得
        let ApiDonationDataDeleteDivisionSelectElementSelectedValue = document.querySelector('input[name="api_donation_data[delete_division]"]:checked');
        if (!!ApiDonationDataDeleteDivisionSelectElementSelectedValue) {
          if (ApiDonationDataDeleteDivisionSelectElementSelectedValue.value == 'undone') {
            // テーブルボディを取得
            let donationIndexTableBody = document.querySelector('#donation-index-table-area table tbody');
            if (!!donationIndexTableBody) {
              // スピナーを表示
              spinnerComponent.spinnerShow();

              setTimeout(function () {
                // すべての行を削除
                let rows = donationIndexTableBody.querySelectorAll('tr')
                if (!!rows.length) {
                  for (var i = 0; i < rows.length; i++) {
                    rows[i].remove();
                  }
                }
                // 空の行を追加
                let newRow = document.createElement('tr');
                newRow.classList.add('nodata');
                let newCell = document.createElement('td');
                newCell.setAttribute('colspan', 6);
                newCell.innerHTML='寄附情報がありません。';
                newRow.appendChild(newCell);
                donationIndexTableBody.appendChild(newRow);
                // スピナーを削除
                spinnerComponent.spinnerHide();
              }, 2000);
            }
          }
        }
      });
    }

    // 閲覧
    donationDataShowAction();

    // ページネート
    stopPagenationSubmitAction();
  }
}

// 寄附情報差し替え
function donationDataReplace(pageNumber=void(0)) {
  // テーブルを取得
  let donationIndexTableArea = document.getElementById('donation-index-table-area');
  if (!!donationIndexTableArea) {
    // 区分
    let ApiDonationDataDivisionSelectElement = document.querySelector('input[name="api_donation_data[division]"]:checked');
    // 区分の選択肢を取得
    let ApiDonationDataDivisionSelectElementSelectedValue = '';
    if (!!ApiDonationDataDivisionSelectElement) {
      ApiDonationDataDivisionSelectElementSelectedValue = ApiDonationDataDivisionSelectElement.value;
    }
    // 削除区分
    let ApiDonationDataDeleteDivisionSelectElement = document.querySelector('input[name="api_donation_data[delete_division]"]:checked');
    // 削除区分の選択肢を取得
    let ApiDonationDataDeleteDivisionSelectElementSelectedValue = '';
    if (!!ApiDonationDataDeleteDivisionSelectElement) {
      ApiDonationDataDeleteDivisionSelectElementSelectedValue = ApiDonationDataDeleteDivisionSelectElement.value;
    }
    // 事業年度
    let ApiDonationDataFiscalYearSelectElement = document.getElementById('api_donation_data_fiscal_year');
    // 事業年度の選択肢を取得
    let ApiDonationDataFiscalYearSelectElementSelectedValue = '';
    if (!!ApiDonationDataFiscalYearSelectElement) {
      ApiDonationDataFiscalYearSelectElementSelectedValue = ApiDonationDataFiscalYearSelectElement.value;
    }
    // クラウドファンディング
    let ApiDonationCrowdFundingSelectElement = document.getElementById('api_donation_data_crowd_funding_id');
    // クラウドファンディングの選択肢を取得
    let ApiDonationCrowdFundingSelectElementSelectedValue = '';
    if (!!ApiDonationCrowdFundingSelectElement) {
      ApiDonationCrowdFundingSelectElementSelectedValue = ApiDonationCrowdFundingSelectElement.value;
    }
    // ページネート
    let pagenationElement = document.querySelector('ul.pagination');
    // data-setからpathを取得
    let path = ApiDonationCrowdFundingSelectElement.dataset['path'];
    // パラメータをセット
    let data = {
      'api_donation_data': {
        'division': ApiDonationDataDivisionSelectElementSelectedValue,                   // 区分の選択肢
        'delete_division': ApiDonationDataDeleteDivisionSelectElementSelectedValue,      // 削除区分の選択肢
        'fiscal_year': ApiDonationDataFiscalYearSelectElementSelectedValue,              // 事業年度の選択肢
        'crowd_funding_id': ApiDonationCrowdFundingSelectElementSelectedValue            // クラウドファンディングの選択肢
      }
    }
    // 現在のページをパラメータに追加
    if (!!pageNumber) {
      data['api_donation_data']['page'] = pageNumber;
    }

    // スピナーを表示
    spinnerComponent.spinnerShow();
    // 一覧を取得
    $.ajax({
      url: path,
      type: 'GET',
      data: data
    })
    .done((respons) => {
      let parentElement = donationIndexTableArea.parentElement;
      if (!!parentElement) {
        donationIndexTableArea.remove();
        parentElement.innerHTML = respons;
        donationDataShowAction();
        stopPagenationSubmitAction();
      }
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      console.log('接続タイムアウトが発生しました。');
    })
    .always((jqXHR, msg) => {
      // スピナーを削除
      spinnerComponent.spinnerHide();
    })
  }
}

// ページネートのリンクを無効化してフォームを送信
function stopPagenationSubmitAction () {
  let linkElements = document.querySelectorAll('ul.pagination a');
  if (!!linkElements.length) {
    for (var i = 0; i < linkElements.length; i++) {
      if (!!linkElements[i]) {
        linkElements[i].addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();

          // リンクのhrefからページ番号を取得
          let url = new URL(this.href);
          let params = url.searchParams;
          let pageNumber = params.get('page');
          donationDataReplace(pageNumber);
        });
      }
    }
  }
}

// 閲覧
function donationDataShowAction() {
  // テーブルを取得
  let donationIndexTableArea = document.getElementById('donation-index-table-area');
  if (!!donationIndexTableArea) {
    let rows = donationIndexTableArea.querySelectorAll('table tbody tr');
    if (!!rows.length) {
      for (var i = 0; i < rows.length; i++) {
        rows[i].addEventListener('click', function(event) {
          // hidden_fieldを取得
          let element = this.querySelector('input[type="hidden"]');
          if (!!element) {
            // リダイレクトするpathを取得
            let path = element.value;
            // 現在のページネートを取得
            let pagenation = donationIndexTableArea.querySelector('ul.pagination li.active a');
            // スピナーを表示
            spinnerComponent.spinnerShow();
            if (!!pagenation) {
              let activePage = pagenation.innerText;
              if (!!path && !!activePage) {
                path = path + "?page=" + activePage;
              }
            }

            let url = new URL(path);
            let xmlHttpRequest = new XMLHttpRequest();
            xmlHttpRequest.open('GET', url)
            xmlHttpRequest.send();

            xmlHttpRequest.onreadystatechange = function() {
              if (xmlHttpRequest.readyState === 4) {
                if (xmlHttpRequest.status === 200) {
                  let target = document.getElementById('c-main');
                  if (!!target) {
                    // レスポンスを受け取る
                    var response_text = xmlHttpRequest.responseText;
                    // 取得した文字列をDOMに変換
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(response_text, 'text/html');
                    // 変換したDOMから必要な要素を取り出して追加
                    var modal = document.querySelector('div.modal');
                    if (!!modal) {
                      modal.replaceWith(doc.body.children[0]);
                    } else {
                      target.appendChild(doc.body.children[0]);
                    }
                    modalComponent.modalOpen();
                  }
                } else {
                  console.log('失敗')
                }
              }
              // スピナーを削除
              spinnerComponent.spinnerHide();
            }
          }
        });
      }
    }
  }
}

// 寄附のお申し込みのアクション
export function donationFormActions () {
  // クラウドファンディング
  let apiDonationFormCrowdFundingId = document.getElementById('api_donation_form_crowd_funding_id');

  // 個人 / 法人
  let apiDonationFormParsonTypeElements = document.getElementsByName('api_donation_form[parson_type]');
  if (!!apiDonationFormParsonTypeElements.length) {
    // ワンストップ特例制度の申請
    let apiDonationFormOnestopElements = document.getElementsByName('api_donation_form[onestop]');
    if (!!apiDonationFormOnestopElements.length) {
      let apiDonationFormParsonTypeParsonElement = document.getElementById('api_donation_form_parson_type_parson');
      if (!!apiDonationFormParsonTypeParsonElement) {
        if (apiDonationFormParsonTypeParsonElement.checked) {
          for (var t = 0; t < apiDonationFormOnestopElements.length; t++) {
            apiDonationFormOnestopElements[t].disabled = false;
          }
          let apiDonationFormOnestopGoodElement = document.getElementById('api_donation_form_onestop_good');
          let apiDonationFormOnestopBadElement = document.getElementById('api_donation_form_onestop_bad');
          if (!!apiDonationFormOnestopGoodElement && !!apiDonationFormOnestopBadElement) {
            if (!apiDonationFormOnestopGoodElement.checked && !apiDonationFormOnestopBadElement.checked) {
              apiDonationFormOnestopBadElement.checked = true;
            }
          }
        } else {
          for (var t = 0; t < apiDonationFormOnestopElements.length; t++) {
            apiDonationFormOnestopElements[t].disabled = true;
          }
        }
      }

      for (var i = 0; i < apiDonationFormParsonTypeElements.length; i++) {
        apiDonationFormParsonTypeElements[i].addEventListener('change', function(event) {
          if (this.value == 'parson') {
            for (var t = 0; t < apiDonationFormOnestopElements.length; t++) {
              apiDonationFormOnestopElements[t].disabled = false;
            }
          } else {
            for (var t = 0; t < apiDonationFormOnestopElements.length; t++) {
              apiDonationFormOnestopElements[t].checked = false;
              apiDonationFormOnestopElements[t].disabled = true;
            }
          }
        });
      }
    }
  }

  // 決済方法
  let paymentMethods = document.querySelectorAll('input[name="api_donation_form[payment_method]"]');
  if (!!paymentMethods.length) {
    togglePaymentMethodMessage();

    for (var i = 0; i < paymentMethods.length; i++) {
      paymentMethods[i].addEventListener('change', function(event) {
        // カード番号のラベル
        let labelCardElement = document.querySelector('label[for=cardno]');
        // カード番号のインプット
        let inputCardno1Element = document.getElementById('cardno1');
        let inputCardno2Element = document.getElementById('cardno2');
        let inputCardno3Element = document.getElementById('cardno3');
        let inputCardno4Element = document.getElementById('cardno4');
        // 有効期限のラベル
        let labelCardRangeElement = document.querySelector('label[for=cardrange]');
        // 有効期限月のインプット
        let inputRangeMonthElement = document.getElementById('range_month');
        // 有効期限年のインプット
        let inputRangeYearElement = document.getElementById('range_year');
        // セキュリティコードのラベル
        let labelSecurityCodeElement = document.querySelector('label[for=securitycode]');
        // セキュリティコードのインプット
        let inputSecurityCodeElement = document.getElementById('securitycode');

        if (this.value == 'card') {
          // カード番号のラベルに必須を追加
          labelCardElement.classList.add('required');
          // カード番号にdisabledを解除
          inputCardno1Element.disabled = false;
          inputCardno2Element.disabled = false;
          inputCardno3Element.disabled = false;
          inputCardno4Element.disabled = false;
          // 有効期限のラベルに必須を追加
          labelCardRangeElement.classList.add('required');
          // 有効期限月にdisabledを解除
          inputRangeMonthElement.disabled = false;
          // 有効期限年にdisabledを解除
          inputRangeYearElement.disabled = false;
          // セキュリティコードのラベルに必須を追加
          labelSecurityCodeElement.classList.add('required');
          // セキュリティコードにdisabledを解除
          inputSecurityCodeElement.disabled = false;
        } else {
          // カード番号のラベルに必須を削除
          labelCardElement.classList.remove('required');
          // カード番号にdisabled
          inputCardno1Element.disabled = true;
          inputCardno2Element.disabled = true;
          inputCardno3Element.disabled = true;
          inputCardno4Element.disabled = true;
          // 有効期限のラベルに必須を削除
          labelCardRangeElement.classList.remove('required');
          // 有効期限月にdisabled
          inputRangeMonthElement.disabled = true;
          // 有効期限年にdisabled
          inputRangeYearElement.disabled = true;
          // セキュリティコードのラベルに必須を削除
          labelSecurityCodeElement.classList.remove('required');
          // セキュリティコードにdisabled
          inputSecurityCodeElement.disabled = true;
        }
        togglePaymentMethodMessage();
      })
    }
  }

  // 寄附の使途の希望
  let useCodes = document.querySelectorAll('input[name="api_donation_form[use_code]"]');
  if (!!useCodes.length) {
    for (var i = 0; i < useCodes.length; i++) {
      if (!!useCodes[i]) {
        useCodes[i].addEventListener('change', function(event) {
          // テーマのラベル
          let labelThemeElement = document.querySelector('label[for=api_donation_form_theme_id]');
          // テーマのセレクト
          let selectThemeElement = document.getElementById('api_donation_form_theme_id');
          // 寄附を行う団体のラベル
          let labelWorkerIdElement = document.querySelector('label[for=api_donation_form_pref_shimane_worker_worker_id]');
          // 寄附を行う団体のセレクト
          let selectPrefShimaneWorkerIdElement = document.getElementById('api_donation_form_pref_shimane_worker_worker_id');
          // 寄附を希望する団体への寄附者情報の提供のラベル
          let labelOfferInformationElement = document.querySelector('label[for=api_donation_form_offer_information]');
          // 全て提供する(寄附を希望する団体への寄附者情報の提供)
          let radioInformationAllElement = document.getElementById('api_donation_form_offer_information_all');
          // 一部提供する(寄附を希望する団体への寄附者情報の提供)
          let radioInformationAnyElement = document.getElementById('api_donation_form_offer_information_any');
          // 提供しない(寄附を希望する団体への寄附者情報の提供)
          let radioInformationNoneElement = document.getElementById('api_donation_form_offer_information_none');
          // お名前(寄附を希望する団体への寄附者情報の提供)
          let checkboxInformationNameElement = document.getElementById('api_donation_form_offer_information_name');
          // ご住所(寄附を希望する団体への寄附者情報の提供)
          let checkboxInformationAddressElement = document.getElementById('api_donation_form_offer_information_address');
          // メールアドレス(寄附を希望する団体への寄附者情報の提供)
          let checkboxInformationEmailElement = document.getElementById('api_donation_form_offer_information_email');
          // 寄附金額(寄附を希望する団体への寄附者情報の提供)
          let checkboxInformationMoneyElement = document.getElementById('api_donation_form_offer_information_money');
          // 団体へ送るメッセージ
          let textAreaMessageElement = document.getElementById('api_donation_form_message');

          if (this.value == 'group') {
            // 寄附を行うテーマのラベルから必須を削除
            if (!!labelThemeElement) {
              labelThemeElement.classList.remove('required');
            }
            // 寄附を行うテーマのセレクトをdisabled
            if (!!selectThemeElement) {
              selectThemeElement.disabled = true;
            }
            // 寄附を行うテーマのラベルに必須を追加
            if (!!labelWorkerIdElement) {
              labelWorkerIdElement.classList.add('required');
            }
            // 寄附を行う団体のセレクトのdisabledを解除
            if (!!selectPrefShimaneWorkerIdElement) {
              selectPrefShimaneWorkerIdElement.disabled = false;
            }
            // 寄附を希望する団体への寄附者情報の提供のラベル
            if (!!labelOfferInformationElement) {
              labelOfferInformationElement.classList.add('required');
            }
            // 全て提供する(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!radioInformationAllElement) {
              radioInformationAllElement.disabled = false;
            }
            // 一部提供する(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!radioInformationAnyElement) {
              radioInformationAnyElement.disabled = false;
            }
            // 提供しない(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!radioInformationNoneElement) {
              radioInformationNoneElement.disabled = false;
            }
            // お名前(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationNameElement) {
              checkboxInformationNameElement.disabled = true;
            }
            // ご住所(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationAddressElement) {
              checkboxInformationAddressElement.disabled = false;
            }
            // メールアドレス(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationEmailElement) {
              checkboxInformationEmailElement.disabled = false;
            }
            // 寄附金額(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationMoneyElement) {
              checkboxInformationMoneyElement.disabled = false;
            }
            // 団体へ送るメッセージのdisabledを解除
            if (!!textAreaMessageElement) {
              textAreaMessageElement.disabled = false;
            }
          } else {
            // 寄附を行うテーマのラベルに必須を追加
            if (!!labelThemeElement) {
              labelThemeElement.classList.add('required');
            }
            // 寄附を行うテーマのセレクトのdisabledを解除
            if (!!selectThemeElement) {
              selectThemeElement.disabled = false;
            }
            // 団体のラベルから必須を削除
            if (!!labelWorkerIdElement) {
              labelWorkerIdElement.classList.remove('required');
            }
            // 寄附を行う団体のセレクトをdisabled
            if (!!selectPrefShimaneWorkerIdElement) {
              selectPrefShimaneWorkerIdElement.disabled = true;
            }
            // 寄附を希望する団体への寄附者情報の提供のラベル
            if (!!labelOfferInformationElement) {
              labelOfferInformationElement.classList.remove('required');
            }
            // 全て提供する(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!radioInformationAllElement) {
              radioInformationAllElement.disabled = true;
            }
            // 一部提供する(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!radioInformationAnyElement) {
              radioInformationAnyElement.disabled = true;
            }
            // 提供しない(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!radioInformationNoneElement) {
              radioInformationNoneElement.disabled = true;
            }
            // お名前(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationNameElement) {
              checkboxInformationNameElement.disabled = true;
            }
            // ご住所(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationAddressElement) {
              checkboxInformationAddressElement.disabled = true;
            }
            // メールアドレス(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationEmailElement) {
              checkboxInformationEmailElement.disabled = true;
            }
            // 寄附金額(寄附を希望する団体への寄附者情報の提供)をdisabled
            if (!!checkboxInformationMoneyElement) {
              checkboxInformationMoneyElement.disabled = true;
            }
            // 団体へ送るメッセージをdisabled
            if (!!textAreaMessageElement) {
              textAreaMessageElement.disabled = true;
            }
          }
        })
      }
    }
  }

  // 寄附を行う団体
  let apiDonationFormWorkerId = document.getElementById('api_donation_form_worker_id');
  if (!!apiDonationFormWorkerId) {
    // テーマ希望寄附
    let apiDonationFormUseCodeTheme = document.getElementById('api_donation_form_use_code_theme');
    // 団体希望寄附
    let apiDonationFormUseCodeGroup = document.getElementById('api_donation_form_use_code_group');

    if (!!apiDonationFormUseCodeTheme && !!apiDonationFormUseCodeGroup) {
      if (!apiDonationFormUseCodeTheme.checked && !apiDonationFormUseCodeGroup.checked) {
        select2Component.apply({ 'disabled': true });
      } else if (apiDonationFormUseCodeTheme.checked) {
        select2Component.apply({ 'disabled': true });
      } else if (!!apiDonationFormCrowdFundingId) {
        if (!!apiDonationFormCrowdFundingId.value) {
          select2Component.apply({ 'disabled': true });
        } else {
          select2Component.apply();
        }
      } else if (apiDonationFormUseCodeGroup.checked) {
        select2Component.apply();
      } else {
        select2Component.apply()
      }
    } else {
      select2Component.apply({ 'disabled': true });
    }
  }

  // 寄附を希望する団体への寄附者情報の提供
  let donationOfferInformationAll = document.getElementById('api_donation_form_offer_information_all');
  if (!!donationOfferInformationAll) {
    // お名前の注意書き
    if (!!donationOfferInformationAll.checked) {
      let donationOfferInformationNameNote = document.getElementById('api_donation_form_offer_information_name').parentNode.parentNode.querySelector('small');
      if (!donationOfferInformationNameNote.classList.contains('d-none')) {
        donationOfferInformationNameNote.classList.add('d-none');
      }
    }

    donationOfferInformationAll.addEventListener('change', function(event) {
      if (donationOfferInformationAll.checked) {
        // お名前
        let donationOfferInformationName = document.getElementById('api_donation_form_offer_information_name');
        if (!!donationOfferInformationName) {
          donationOfferInformationName.checked = true;
          donationOfferInformationName.disabled = true;

          // お名前の注意書き
          let donationOfferInformationNameNote = donationOfferInformationName.parentNode.parentNode.querySelector('small');
          if (!donationOfferInformationNameNote.classList.contains('d-none')) {
            donationOfferInformationNameNote.classList.add('d-none');
          }
        }
        // ご住所
        let donationOfferInformationAddress = document.getElementById('api_donation_form_offer_information_address');
        if (!!donationOfferInformationAddress) {
          donationOfferInformationAddress.checked = true;
          donationOfferInformationAddress.disabled = true;
        }
        // メールアドレス
        let donationOfferInformationEmail = document.getElementById('api_donation_form_offer_information_email');
        if (!!donationOfferInformationEmail) {
          donationOfferInformationEmail.checked = true;
          donationOfferInformationEmail.disabled = true;
        }
        // 寄附金額
        let donationOfferInformationMoney = document.getElementById('api_donation_form_offer_information_money');
        if (!!donationOfferInformationMoney) {
          donationOfferInformationMoney.checked = true;
          donationOfferInformationMoney.disabled = true;
        }
      }
    })
  }

  let donationOfferInformationAny = document.getElementById('api_donation_form_offer_information_any');
  if (!!donationOfferInformationAny) {
    if (!!donationOfferInformationAny.checked) {
      // お名前の注意書き
      let donationOfferInformationNameNote = document.getElementById('api_donation_form_offer_information_name').parentNode.parentNode.querySelector('small');
      if (!!donationOfferInformationNameNote) {
        if (!!donationOfferInformationNameNote.classList.contains('d-none')) {
          donationOfferInformationNameNote.classList.remove('d-none');
        }
      }
    }

    donationOfferInformationAny.addEventListener('change', function(event) {
      if (donationOfferInformationAny.checked) {
        // お名前
        let donationOfferInformationName = document.getElementById('api_donation_form_offer_information_name');
        if (!!donationOfferInformationName) {
          donationOfferInformationName.checked = true;
          donationOfferInformationName.disabled = true;

          // お名前の注意書き
          let donationOfferInformationNameNote = donationOfferInformationName.parentNode.parentNode.querySelector('small');
          if (!!donationOfferInformationNameNote) {
            if (!!donationOfferInformationNameNote.classList.contains('d-none')) {
              donationOfferInformationNameNote.classList.remove('d-none');
            }
          }
        }
        // ご住所
        let donationOfferInformationAddress = document.getElementById('api_donation_form_offer_information_address');
        if (!!donationOfferInformationAddress) {
          donationOfferInformationAddress.checked = false;
          donationOfferInformationAddress.disabled = false;
        }
        // メールアドレス
        let donationOfferInformationEmail = document.getElementById('api_donation_form_offer_information_email');
        if (!!donationOfferInformationEmail) {
          donationOfferInformationEmail.checked = false;
          donationOfferInformationEmail.disabled = false;
        }
        // 寄附金額
        let donationOfferInformationMoney = document.getElementById('api_donation_form_offer_information_money');
        if (!!donationOfferInformationMoney) {
          donationOfferInformationMoney.checked = false;
          donationOfferInformationMoney.disabled = false;
        }
      }
    })
  }

  let donationOfferInformationNone = document.getElementById('api_donation_form_offer_information_none');
  if (!!donationOfferInformationNone) {
    if (!!donationOfferInformationNone.checked) {
      // お名前の注意書き
      let donationOfferInformationNameNote = document.getElementById('api_donation_form_offer_information_name').parentNode.parentNode.querySelector('small');
      if (!!donationOfferInformationNameNote) {
        if (!donationOfferInformationNameNote.classList.contains('d-none')) {
          donationOfferInformationNameNote.classList.add('d-none');
        }
      }
    }

    donationOfferInformationNone.addEventListener('change', function(event) {
      if (donationOfferInformationNone.checked) {
        // お名前
        let donationOfferInformationName = document.getElementById('api_donation_form_offer_information_name');
        if (!!donationOfferInformationName) {
          donationOfferInformationName.checked = false;
          donationOfferInformationName.disabled = true;

          // お名前の注意書き
          let donationOfferInformationNameNote = donationOfferInformationName.parentNode.parentNode.querySelector('small');
          if (!!donationOfferInformationNameNote) {
            if (!donationOfferInformationNameNote.classList.contains('d-none')) {
              donationOfferInformationNameNote.classList.add('d-none');
            }
          }
        }
        // ご住所
        let donationOfferInformationAddress = document.getElementById('api_donation_form_offer_information_address');
        if (!!donationOfferInformationAddress) {
          donationOfferInformationAddress.checked = false;
          donationOfferInformationAddress.disabled = true;
        }
        // メールアドレス
        let donationOfferInformationEmail = document.getElementById('api_donation_form_offer_information_email');
        if (!!donationOfferInformationEmail) {
          donationOfferInformationEmail.checked = false;
          donationOfferInformationEmail.disabled = true;
        }
        // 寄附金額
        let donationOfferInformationMoney = document.getElementById('api_donation_form_offer_information_money');
        if (!!donationOfferInformationMoney) {
          donationOfferInformationMoney.checked = false;
          donationOfferInformationMoney.disabled = true;
        }
      }
    })
  }

  // 確認ボタン
  let check = document.getElementById('check');
  if (!!check) {
    check.addEventListener('click', function(event) {
      // 確認ボタンの無効化
      check.disabled = true;
      // 決済方法のクレジットカードを取得
      let paymentMethodCard = document.getElementById('api_donation_form_payment_method_card');
      // 送信するフォーム
      let form = document.getElementById('c-main').querySelector('form');

      if (!!paymentMethodCard) {
        if (!!paymentMethodCard.checked) {
          callSetToken(form, check);
        } else {
          // APIトークン
          let inputApiTokenElement = document.getElementById('api_donation_form_api_token');
          // APIカードNo
          let inputApiCardNoElement = document.getElementById('api_donation_form_api_card_no');
          // APIトークン
          inputApiTokenElement.value = '';
          // APIカードNo
          inputApiCardNoElement.value = '';
          // フォーム送信
          form.submit();
        }
      } else {
        // 決済方法（hidden_field）を取得
        let hiddenPaymentMethod = document.getElementsByName('api_donation_form[payment_method]');
        if (!!hiddenPaymentMethod) {
          callSetToken(form, check);
        } else {
          form.submit();
        }
      }
    });
  }

  // 訂正ボタン
  let correction = document.getElementById('correction');
  // 確定ボタン
  let confirm = document.getElementById('confirm');
  if (!!correction && !!confirm) {
    let form = document.getElementById('c-main').querySelector('form');

    // 訂正ボタンイベント
    correction.addEventListener('click', function(event) {
      // 訂正ボタンの無効化
      correction.disabled = true;
      // 確定ボタンの無効化
      confirm.disabled = true;
      form.action = document.getElementById('new_donation_path').value;
      form.method = 'get';
      form.submit();
    });

    // 確定ボタンイベント
    form.addEventListener('submit', function(event) {
      // 訂正ボタンの無効化
      correction.disabled = true;
      // 確定ボタンの無効化
      confirm.disabled = true;
      return true;
    });

    // 確定ボタンイベントのレスポンスを受け取る
    document.addEventListener('ajax:success', function(event) {
      if (event.target == form) {
        let data = JSON.parse(event.detail[0]);

        if (!!data['cash']) {
          form.submit();
          return;
        }

        let hiddenform = document.createElement('form');
        hiddenform.setAttribute('id', 'hiddenform')
        hiddenform.setAttribute('method', 'post');
        hiddenform.setAttribute('action', data['uri']);

        let hiddenMerchantId = document.createElement('input');
        hiddenMerchantId.setAttribute('type', 'hidden');
        hiddenMerchantId.setAttribute('name', 'MerchantId');
        hiddenMerchantId.setAttribute('value', data['MerchantId']);
        hiddenform.appendChild(hiddenMerchantId);

        let hiddenEncryptValue = document.createElement('input');
        hiddenEncryptValue.setAttribute('type', 'hidden');
        hiddenEncryptValue.setAttribute('name', 'EncryptValue');
        hiddenEncryptValue.setAttribute('value', data['EncryptValue']);
        hiddenform.appendChild(hiddenEncryptValue);

        document.body.appendChild(hiddenform);
        hiddenform.submit();
      }
    });

    document.addEventListener('ajax:error', function(event) {
      if (event.target == form) {
        location.href = '/donations/hindrance';
      }
    });
  }
}

function togglePaymentMethodMessage () {
  let paymentMethodCardButton = document.getElementById('api_donation_form_payment_method_card');

  if (!!paymentMethodCardButton) {
    let paymentCashMessageElement = document.getElementById('payment-cash-message');

    if (!!paymentCashMessageElement) {
      if (!!paymentMethodCardButton.checked) {
        paymentCashMessageElement.classList.remove('d-block');
        paymentCashMessageElement.classList.add('d-none');
      } else {
        if (!paymentCashMessageElement.classList.contains('d-block')) {
          paymentCashMessageElement.classList.add('d-block');
          paymentCashMessageElement.classList.remove('d-none');
        }
      }
    }
  }
}

function callSetToken(form, button) {
  // 数字の正規表現
  const numberRegex = new RegExp(/^[0-9]+$/);
  // 入力された内容を取得
  let cardNo1 = document.getElementById('cardno1');
  let cardNo2 = document.getElementById('cardno2');
  let cardNo3 = document.getElementById('cardno3');
  let cardNo4 = document.getElementById('cardno4');
  let cardNo = '';
  if (!!cardNo1 && !!cardNo2 && !!cardNo3 && !!cardNo4) {
    cardNo = cardNo1.value + cardNo2.value + cardNo3.value + cardNo4.value;
  }
  let cardRangeYear = document.getElementById('range_year');
  let cardRangeMonth = document.getElementById('range_month');
  let securityCode = document.getElementById('securitycode');
  if (!!cardNo && !!cardRangeYear && !!cardRangeMonth && !!securityCode) {
    if (cardNo.length > 13 && !!cardRangeYear.value && !!cardRangeMonth.value && !!securityCode.value && !!numberRegex.test(cardNo) && !!numberRegex.test(securityCode.value)) {
      // 送信
      SpsvApi.spsvCreateToken(cardNo, cardRangeYear.value, cardRangeMonth.value, securityCode.value,'','','','','')
    } else {
      // 確認ボタンの無効化
      button.disabled = false;
      alert('カード情報をもう一度入力してください。')
    }

    // 以下情報を送信しない
    cardNo1.value = '';
    cardNo2.value = '';
    cardNo3.value = '';
    cardNo4.value = '';
    cardRangeYear.value = '';
    cardRangeMonth.value = '';
    securityCode.value = '';
  } else if (!cardNo || !cardRangeYear || !cardRangeMonth || !securityCode) {
    // 確認ボタンの無効化
    button.disabled = false;
    alert('カード情報をもう一度入力してください。')

    // 以下情報を送信しない
    cardNo1.value = '';
    cardNo2.value = '';
    cardNo3.value = '';
    cardNo4.value = '';
    cardRangeYear.value = '';
    cardRangeMonth.value = '';
    securityCode.value = '';
  } else {
    form.submit();
  }
}

window.setToken = function setToken(token, cardNo) {
  let apiToken = document.getElementById('api_donation_form_api_token');
  let apiCardNo = document.getElementById('api_donation_form_api_card_no');

  if (!!apiCardNo) {
    apiCardNo.value = cardNo;
  }

  if (!!apiToken) {
    apiToken.value = token;
  }

  let form = document.getElementById('c-main').querySelector('form');
  form.submit();
}
